import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const FormSection = styled.div`
  flex: 1 0 auto;
  grid-area: content;
`;

export const FormContainer = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  max-width: 700px;
  margin: ${theme.space[0]} auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  button:first-child {
    margin-right: 12px;
  }
`;

export const PanelCss = css`
  box-shadow: none;
`;

export const FormWrapperCss = css`
  fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    box-sizing: border-box;
  }

  .form-group {
    width: 100%;
    margin-bottom: ${theme.space[4]};
    &:last-child {
      margin-bottom: 0;
    }
  }

  legend {
    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
    font-size: ${theme.fontSizes[3]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights[4]};
    margin-block-start: 0em;
    margin-bottom: 1.2rem;
    padding-bottom: 1.2rem;
    width: 100%;
  }

  .field-description {
    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
    color: ${theme.colors.darkBlues[75]};
    font-size: ${theme.fontSizes[0]};
    margin-block-start: 0em;
    margin-bottom: 1.2rem;
    padding-bottom: 1.2rem;
  }

  label {
    display: flex;
    gap: ${theme.space[1]};
    flex-wrap: wrap;
    font-size: ${theme.fontSizes[0]};
    font-weight: ${theme.fontWeights.semibold};
    line-height: ${theme.lineHeights[1]};
    margin-bottom: ${theme.space[1]};
    color: ${theme.colors.darkBlues[90]};
  }

  .error-detail.bs-callout.bs-callout-info,
  label.control-label {
    display: none;
  }

  input {
    width: 100%;
  }

  textarea {
    width: calc(100% - ${theme.space[5]});
  }
  .meta-section-header {
    border-bottom: ${theme.borders[0]} solid ${theme.colors.darkBlues[10]};
    margin-bottom: ${theme.space[4]};
    padding-bottom: ${theme.space[2]};

    legend {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .with-tooltip-title,
  .box p {
    white-space: pre-wrap;
    line-height: ${theme.lineHeights[3]};
    font-size: ${theme.fontSizes[2]};
    margin-bottom: ${theme.space[1]};
  }
  .box {
    vertical-align: top;
    margin-bottom: ${theme.space[4]};
  }
  .label {
    font-size: ${theme.fontSizes[0]};
    color: ${theme.colors.darkBlues[90]};
    line-height: ${theme.lineHeights[2]};
    font-weight: ${theme.fontWeights.semibold};
  }
`;
